import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, Grid, Tooltip } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Node } from 'slate';
import setToast from "../../helpers/toaster.helper";
import { BackIcon, CancelIcon, DisableResetIcon, ResetIcon } from "../../icon";
import { AlertNotificationModel, AlertStatus, AlertsLinkType, ReleaseAlertType } from "../../models/alert.model";
import * as selector from "../../selectors/selectors";
import { AlertNotificationService } from "../../services/AlertNotificationService";
import { UtilityService } from "../../services/UtilityService";
import ButtonComponent from "../shared/button/button.component";
import { ToasterTexts, buttonLabels } from "../shared/constants";
import DateAndTimePicker from '../shared/datetimepicker/date-timepicker.component';
import { validateForm } from "../shared/form-validation";
import RichEditor from "../shared/richtext-editor/rich-text-editor.component";
import { ToasterType } from "../shared/toaster/toaster.model";

let alertTypes = [{ Name: "Release", Value: 1 }];
let alertButtons = [{ Name: "Link", Value: 1 }, { Name: "Button", Value: 2 }];

const initialValue: Node[] = [
    {
        type: "paragraph",
        children: [{ text: "" }]
    }
];


interface Props {
    ShowAddAlert: boolean;
    OnClose: (isConfim: boolean) => void;
    AlertData?: AlertNotificationModel;
    rowId: string;
}

const AddAlertsComponent = (props: Props) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const [alertTitle, setAlertTitle] = useState<string>(!!props.AlertData?.ID ? "Edit Alert" : "Add Alert")
    const [IsLoading, setIsLoading] = useState<boolean>(false)
    const [userinput, setUserinput] = useState<{
        ID: string;
        Type: ReleaseAlertType | -1;
        Title: string;
        SubTitle: string;
        Description: Node[];
        LinkType: AlertsLinkType | -1;
        DisplyText: string;
        Link: string;
        StartDateTime: number;
        EndDateTime: number;
        Occurrence: number;
        Status: AlertStatus | -1;
        IsDeleted: boolean;
    }>({
        ...(props.AlertData || {
            ID: "",
            Type: -1,
            Title: "",
            SubTitle: "",
            LinkType: -1,
            DisplyText: "",
            Link: "",
            StartDateTime: -1,
            EndDateTime: -1,
            Occurrence: 1,
            Status: -1,
            IsDeleted: false,
            Description: initialValue
        })
    })
    const [errors, setErrors] = useState<{
        ID: string,
        Type: string,
        Title: string,
        SubTitle: string,
        LinkType: string,
        DisplyText: string,
        Link: string,
        StartDateTime: string,
        EndDateTime: string,
        Occurrence: string,
        Status: string,
        Description: string,
    }>({
        ID: "",
        Type: "",
        Title: "",
        SubTitle: "",
        LinkType: "",
        DisplyText: "",
        Link: "",
        StartDateTime: "",
        Description: "",
        EndDateTime: "",
        Occurrence: "",
        Status: "",
    })

    const formSubmit = (event: any) => {
        event.preventDefault();
        var Des = JSON.stringify(userinput.Description).length === JSON.stringify(initialValue).length;
        if (validateForm({ Type: userinput.Type, Title: userinput.Title, SubTitle: userinput.SubTitle, Description: !Des, LinkType: userinput.LinkType, DisplyText: userinput.DisplyText, Link: userinput.Link }, (Errors) => {
            setErrors({ ...errors, ...Errors })
        })) {
            setIsLoading(true)
            let data: any = {
                "id": userinput.ID,
                "type": userinput.Type,
                "title": userinput.Title,
                "subTitle": userinput.SubTitle,
                "description": JSON.stringify(userinput.Description),
                "status": AlertStatus.SCHEDULED,
                "linkType": userinput.LinkType,
                "displyText": userinput.DisplyText,
                "link": userinput.Link,
                "startDateTime": UtilityService.convertToLocalTimeZone(userinput.StartDateTime).toISOString(),
                "endDateTime": UtilityService.convertToLocalTimeZone(userinput.EndDateTime).toISOString(),
                "occurrence": Number(userinput.Occurrence),
                "isDeleted": userinput.IsDeleted,
            }
            if (!!userinput.ID) {
                AlertNotificationService.updateAlertNotification(data)
                    .then(() => {
                        setIsLoading(false)
                        setToast(ToasterTexts.ALERT_EDIT_SUCCESS, ToasterType.SUCCESS)
                        props.OnClose(true);
                    })
                    .catch((err) => {
                        if (err.response.status === 400) {
                            props.OnClose(true);
                            setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
                            setIsLoading(false)
                        }

                    });
            } else {
                AlertNotificationService.createAlertNotification(data)
                    .then(() => {
                        setIsLoading(false)
                        setToast(ToasterTexts.ALERT_ADD_SUCCESS, ToasterType.SUCCESS)
                        props.OnClose(true);
                    })
                    .catch((err) => {
                        if (err.response.status === 400) {
                            props.OnClose(true);
                            setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
                            setIsLoading(false)
                        }
                    });
            }
        } else {
        }
    }

    const handleStartTimeDate = (scheduleTimeDate: number) => {
        setUserinput({ ...userinput, StartDateTime: scheduleTimeDate })
    }

    const handleEndTimeDate = (scheduleTimeDate: number) => {
        setUserinput({ ...userinput, EndDateTime: scheduleTimeDate })
    }

    const ResetStartDateTime = (e: any) => {
        e.preventDefault();
        setUserinput({ ...userinput, StartDateTime: -1 })
    }

    const ResetEndDateTime = (e: any) => {
        e.preventDefault();
        setUserinput({ ...userinput, EndDateTime: -1 })
    }

    const handleChange = (name: any, value: any) => {
        validateForm({ [name]: value },
            (Errors) => {
                setErrors({ ...errors, ...Errors })
            })
        setUserinput({ ...userinput, [name]: value })
    };

    const handleChangeDes = (value: Node[]) => {
        setUserinput({ ...userinput, Description: value })
    }

    return (
        <div className="w-fill">
            {
                IsMobileDevice ?
                    <div className="paper-background o-x-hidden w-fill h-v-100">
                        <Grid item xs={12}>
                            <div className='box-shadow-display-background-shadow d-flex p-2'>
                                {IsMobileDevice && <span><BackIcon className={"c-pointer pr-2"} onClick={() => props.OnClose(false)} /></span>}
                                <span className={`h1 my-auto color-add-details-title mr-auto`}>{alertTitle}</span>
                            </div>
                        </Grid>
                        <form
                            noValidate
                            autoComplete="no"
                            onSubmit={formSubmit}
                            className="m-2"
                        >
                            <Grid container direction="column" spacing={3} className="mt-2">
                                <Grid item xs={12}>
                                    <Autocomplete
                                        size="small"
                                        className={"w-fill"}
                                        classes={{ input: ` color-text-field-font`, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={alertTypes}
                                        getOptionLabel={(option: any) => option.Name}
                                        onChange={(event: any, value: any | null) => {
                                            if (value) {
                                                setUserinput({ ...userinput, Type: value.Value })
                                                setErrors({ ...errors, Type: "" })
                                            }
                                            else {
                                                setUserinput({ ...userinput, Type: 1 })
                                                setErrors({ ...errors, Type: "Type cannot be blank" })
                                            }
                                        }}
                                        value={alertTypes.find(x => x.Value === userinput.Type) || { Name: "", Value: -1 }}
                                        renderOption={(defaultprops, option: any) => (
                                            <li{...defaultprops} className={` color-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                                                {option.Name}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} name="Type" required variant="outlined" label="Type" placeholder="Type" />}
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {errors.Type}
                                    </FormHelperText>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField autoFocus
                                        name="Title"
                                        placeholder="Title"
                                        label="Title"
                                        variant="outlined"
                                        size="small"
                                        required
                                        fullWidth
                                        value={userinput.Title}
                                        onChange={(e) => handleChange(e.target.name, e.target.value)
                                        }
                                        InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                        autoComplete='no'
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {errors.Title}
                                    </FormHelperText>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        name="SubTitle"
                                        placeholder="SubTitle"
                                        label="SubTitle"
                                        variant="outlined"
                                        size="small"
                                        required
                                        fullWidth
                                        value={userinput.SubTitle}
                                        onChange={(e) => handleChange(e.target.name, e.target.value)
                                        }
                                        InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                        autoComplete='no'
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {errors.SubTitle}
                                    </FormHelperText>
                                </Grid>

                                <Grid item xs={12}>
                                    <RichEditor IsMobileDevice={IsMobileDevice} value={userinput.Description} setValue={(value: Node[]) => handleChangeDes(value)} />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {errors.Description}
                                    </FormHelperText>
                                </Grid>
                                <Grid item xs={12}>
                                    <Autocomplete
                                        size="small"
                                        className={"w-fill"}
                                        classes={{ input: 'h2 color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={alertButtons}
                                        getOptionLabel={(option: any) => option.Name}
                                        onChange={(event: any, value: any | null) => {
                                            if (value) {
                                                setUserinput({ ...userinput, LinkType: value.Value })
                                                setErrors({ ...errors, LinkType: "" })
                                            }
                                            else {
                                                setUserinput({ ...userinput, LinkType: 1 })
                                                setErrors({ ...errors, LinkType: "Type cannot be blank" })
                                            }
                                        }}
                                        value={alertButtons.find(x => x.Value === userinput.LinkType) || { Name: "", Value: -1 }}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} className={"h2 color-primary-dark p-2 d-flex justify-between w-p-90"}>
                                                {option.Name}
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} name="Button" required variant="outlined" label="Button" placeholder="Button" />}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        name="DisplyText"
                                        placeholder="Text to display"
                                        label="Text to display"
                                        variant="outlined"
                                        size="small"
                                        required
                                        fullWidth
                                        value={userinput.DisplyText}
                                        onChange={(e) => handleChange(e.target.name, e.target.value)
                                        }
                                        InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                        autoComplete='no'
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {errors.DisplyText}
                                    </FormHelperText>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        name="Link"
                                        placeholder="Link"
                                        label="Link"
                                        variant="outlined"
                                        size="small"
                                        required
                                        fullWidth
                                        value={userinput.Link}
                                        onChange={(e) => handleChange(e.target.name, e.target.value)
                                        }
                                        InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                        autoComplete='no'
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {errors.Link}
                                    </FormHelperText>
                                </Grid>
                                <Grid item xs={12}>
                                    <div className="d-flex justify-between">
                                        <DateAndTimePicker handleChange={handleStartTimeDate} DateTime={userinput.StartDateTime} TextLabel={"From"} />
                                        <Tooltip title='Reset Date' placement='bottom'>
                                            <button className={"my-auto d-flex c-pointer"} onClick={ResetStartDateTime} >
                                                {userinput.StartDateTime !== -1 ? <ResetIcon className={`icon-primary p-1 my-auto c-pointer`} /> : <DisableResetIcon className={`icon-primary p-1 my-auto c-pointer`} />}
                                            </button>
                                        </Tooltip>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div className="d-flex justify-between">
                                        <DateAndTimePicker handleChange={handleEndTimeDate} DateTime={userinput.EndDateTime} TextLabel={"To"} />
                                        <Tooltip title='Reset Date' placement='bottom'>
                                            <button className={"d-flex my-auto"} onClick={ResetEndDateTime} >
                                                {userinput.EndDateTime !== -1 ? <ResetIcon className={`icon-primary p-1 my-auto c-pointer`} /> : <DisableResetIcon className={`icon-primary p-1 my-auto c-pointer`} />}
                                            </button>
                                        </Tooltip>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        name="Occurrence"
                                        placeholder="Occurrence"
                                        label="Occurrence"
                                        variant="outlined"
                                        size="small"
                                        required
                                        fullWidth
                                        value={userinput.Occurrence}
                                        onChange={(e) => handleChange(e.target.name, e.target.value)
                                        }
                                        InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                        autoComplete='no'
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {errors.Occurrence}
                                    </FormHelperText>
                                </Grid>
                            </Grid>
                        </form>
                        <div className={`px-2`}>
                            <ButtonComponent OnClick={formSubmit} Loading={IsLoading} ButtonLabel={buttonLabels.SAVE.toUpperCase()} ClassName={"w-p-100 justify-center mb-2 br-6"} Variant={"primary-btn-small"} />
                            <ButtonComponent OnClick={() => props.OnClose(false)} ButtonLabel={buttonLabels.CANCEL.toUpperCase()} ClassName={"w-p-100 justify-center mb-2 br-6"} Variant={"secondary-btn-small"} />
                        </div>
                    </div> :
                    <Dialog maxWidth="lg" fullWidth={true} open={props.ShowAddAlert} BackdropProps={{ style: { backgroundColor: "transparent" } }} classes={{ paper: "w-80 br-2 dialogue-shadow" }}>
                        <DialogTitle id="alert-dialog-title" className="dialog-header p-2">
                            <div className='d-flex'>
                                <span className={"h2-regular color-display-title"}>{alertTitle}</span>
                                <Tooltip title='Close' placement='bottom-start'>
                                    <CancelIcon className={"c-pointer ml-auto"} onClick={() => props.OnClose(false)} />
                                </Tooltip>
                            </div>
                        </DialogTitle>
                        <div className={"bb-primary-background-pink-4 mx-2"}></div>
                        <DialogContent className=" p-2 o-x-hidden">
                            <form onSubmit={formSubmit} noValidate autoComplete="off">
                                <Grid container spacing={2}>
                                    <Grid item xs={5} >
                                        <Autocomplete
                                            size="small"
                                            className={"w-fill"}
                                            classes={{ input: `color-text-field-font`, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                            options={alertTypes}
                                            getOptionLabel={(option: any) => option.Name}
                                            onChange={(event: any, value: any | null) => {
                                                if (value) {
                                                    setUserinput({ ...userinput, Type: value.Value })
                                                    setErrors({ ...errors, Type: "" })

                                                }
                                                else {
                                                    setUserinput({ ...userinput, Type: 1 })
                                                    setErrors({ ...errors, Type: "Type cannot be blank" })
                                                }
                                            }}
                                            value={alertTypes.find(x => x.Value === userinput.Type) || { Name: "", Value: -1 }}
                                            renderOption={(defaultprops, option: any) => (
                                                <li {...defaultprops}>
                                                    <span className={`color-menu-list-font-color p-2 d-flex justify-between w-p-80`}>
                                                        {option.Name}
                                                    </span>
                                                </li>
                                            )}
                                            renderInput={(params) => <TextField {...params} name="Type" required variant="outlined" label="Type" placeholder="Type" />}
                                        />
                                        <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                            {errors.Type}
                                        </FormHelperText>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField autoFocus
                                            name="Title"
                                            placeholder=" "
                                            label="Title"
                                            variant="outlined"
                                            size="small"
                                            required
                                            fullWidth
                                            value={userinput.Title}
                                            onChange={(e) => handleChange(e.target.name, e.target.value)
                                            }
                                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                            autoComplete='no'
                                        />
                                        <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                            {errors.Title}
                                        </FormHelperText>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <TextField
                                            name="SubTitle"
                                            placeholder="SubTitle"
                                            label="SubTitle"
                                            variant="outlined"
                                            size="small"
                                            required
                                            fullWidth
                                            value={userinput.SubTitle}
                                            onChange={(e) => handleChange(e.target.name, e.target.value)
                                            }
                                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                            autoComplete='no'
                                        />
                                        <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                            {errors.SubTitle}
                                        </FormHelperText>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <RichEditor value={userinput.Description} setValue={(value: Node[]) => handleChangeDes(value)} IsMobileDevice={IsMobileDevice} />
                                        <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                            {errors.Description}
                                        </FormHelperText>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Autocomplete
                                            size="small"
                                            className={"w-fill"}
                                            classes={{ input: 'h2 color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                            options={alertButtons}
                                            getOptionLabel={(option: any) => option.Name}
                                            onChange={(event: any, value: any | null) => {
                                                if (value) {
                                                    setUserinput({ ...userinput, LinkType: value.Value })
                                                    setErrors({ ...errors, LinkType: "" })

                                                }
                                                else {
                                                    setUserinput({ ...userinput, LinkType: 1 })
                                                    setErrors({ ...errors, LinkType: "Type cannot be blank" })
                                                }
                                            }}

                                            value={alertButtons.find(x => x.Value === userinput.LinkType) || { Name: "", Value: -1 }}
                                            renderOption={(defaultprops, option: any) => (
                                                <li {...defaultprops}>
                                                    <span className={"h2 color-primary-dark p-2 d-flex justify-between w-p-75"}>
                                                        {option.Name}
                                                    </span>
                                                </li>
                                            )}
                                            renderInput={(params) => <TextField {...params} name="Button" required variant="outlined" label="Button" placeholder="Button" />}
                                        />
                                    </Grid>
                                    <Grid item xs={3} >
                                        <TextField
                                            name="DisplyText"
                                            placeholder="Text to display"
                                            label="Text to display"
                                            variant="outlined"
                                            size="small"
                                            required
                                            fullWidth
                                            value={userinput.DisplyText}
                                            onChange={(e) => handleChange(e.target.name, e.target.value)
                                            }
                                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                            autoComplete='no'
                                        />
                                        <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                            {errors.DisplyText}
                                        </FormHelperText>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            name="Link"
                                            placeholder="Link"
                                            label="Link"
                                            variant="outlined"
                                            size="small"
                                            required
                                            fullWidth
                                            value={userinput.Link}
                                            onChange={(e) => handleChange(e.target.name, e.target.value)
                                            }
                                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                            autoComplete='no'
                                        />
                                        <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                            {errors.Link}
                                        </FormHelperText>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <DateAndTimePicker handleChange={handleStartTimeDate} DateTime={userinput.StartDateTime} TextLabel={"From"} />
                                    </Grid>
                                    <Grid item xs={1} className={`d-flex my-auto p-0`}>
                                        <Tooltip title='Reset Date' placement='bottom'>
                                            <button className={"my-auto d-flex c-pointer"} onClick={ResetStartDateTime}>
                                                {userinput.StartDateTime !== -1 ? <ResetIcon className={`icon-primary p-1 my-auto c-pointer`} /> : <DisableResetIcon className={`icon-primary p-1 my-auto c-pointer`} />}
                                            </button>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <DateAndTimePicker handleChange={handleEndTimeDate} DateTime={userinput.EndDateTime} TextLabel={"To"} />
                                    </Grid>
                                    <Grid item xs={1} className="d-flex my-auto p-0">
                                        <Tooltip title='Reset Date' placement='bottom'>
                                            <button className={"d-flex my-auto"} onClick={ResetEndDateTime} >
                                                {userinput.EndDateTime !== -1 ? <ResetIcon className={`icon-primary p-1 my-auto c-pointer`} /> : <DisableResetIcon className={`icon-primary p-1 my-auto c-pointer`} />}
                                            </button>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <TextField
                                            name="Occurrence"
                                            placeholder="Occurrence"
                                            label="Occurrence"
                                            variant="outlined"
                                            size="small"
                                            required
                                            fullWidth
                                            value={userinput.Occurrence}
                                            onChange={(e) => handleChange(e.target.name, e.target.value)
                                            }
                                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                            autoComplete='no'
                                        />
                                        <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                            {errors.Occurrence}
                                        </FormHelperText>
                                    </Grid>
                                </Grid>
                            </form>
                        </DialogContent>
                        <DialogActions className="p-2">
                            <ButtonComponent OnClick={() => props.OnClose(false)} ButtonLabel={buttonLabels.CANCEL} ClassName={""} Variant={"secondary-btn-small"} />
                            <ButtonComponent OnClick={formSubmit} Loading={IsLoading} ButtonLabel={buttonLabels.SAVE} ClassName={"px-4 "} Variant={"primary-btn-small"} />
                        </DialogActions>
                    </Dialog>}
        </div>
    )
}


export default AddAlertsComponent;